import callAPI from "../callApi";
import path from "../variables";

const enterpriseFeatures = {
	getAll: (filter?: string) =>
		callAPI("GET", `${path.base}/administration/enterprise-features${filter ?? ""}`, "", "getting enterprise features"),
	toggle: (data: any) =>
		callAPI("PUT", `${path.base}/administration/enterprise-features/toggle`, data, "toggling enterprise feature"),
	bulkUpdate: (data: any) =>
		callAPI("PUT", `${path.base}/administration/enterprise-features/bulk`, data, "bulk updating enterprise features"),
};

export default enterpriseFeatures;
